<template>
  <div class="page-module">
    <div class="image-code"><img :src="h5HomeCode" alt=""></div>
    <div class="content-code">
      <div class="line-text">下载并分享平台二维码<br/>引导更多用户进入看看</div>
      <a-select placeholder="请选择" v-model="selectCode" @change="handleSelectChange">
        <a-select-option v-for="item in list" :key="item.code" :value="item.code">{{ item.label }}</a-select-option>
      </a-select>
      <a @click="downloadIamge(h5HomeCode)">下载二维码</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QrCodeModule',
  props: {
    type: {
      type: Number,
      default: 0//3是会员卡用，0是默认H5移动端 1是小程序处理
    },
    address: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectCode: 250,
      list: [
        { label: '小 250', code: 250 }, { label: '中 430', code: 430 }, { label: '大 860', code: 860 }
      ],
      h5HomeCode: '',
      merchantId: this.$store.getters.userInfo.merchantId,
      token: this.$store.getters.token,
      platformId: this.getPlatformConfig().platformId
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getCodeUrl()
    })
  },
  watch: {
    address(newVal, oldValue) {
      this.getCodeUrl()
    }
  },
  methods: {
    getCodeUrl() {
      this.getLogUtils().logWithTag('getCodeUrl', this.getAppConfig().baseUrl)
      if (this.type == 0) {
        this.h5HomeCode = this.getAppConfig().userUrl + 'homepage/H5/get/qrCode/' + this.selectCode + '/' + this.merchantId + '/1/' + this.merchantId + '/' + this.platformId
      } else if (this.type == 3) {
        this.h5HomeCode = this.getAppConfig().baseUrl + 'code/getQRCode?url=' + encodeURIComponent(this.address) + '&size=' + this.selectCode
      } else {
        this.h5HomeCode = this.getAppConfig().userUrl + 'api/v2/wx/auth/getQrcode?width=' + this.selectCode + '&type=' + this.type + '&merchantId=' + this.merchantId + '&platformId=' + this.platformId
      }
      this.getLogUtils().logWithTag('getCodeUrl', this.h5HomeCode)
    },
    handleSelectChange(value) {
      this.getLogUtils().logWithTag('选择', value)
      this.selectCode = value
      this.getCodeUrl()
    },
    downloadIamge(imgsrc, name) {//下载图片地址和图片名
      var image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function() {
        var canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var url = canvas.toDataURL('image/png') //得到图片的base64编码数据

        var a = document.createElement('a') // 生成一个a元素
        var event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    }
  }

}
</script>
<style lang="less" scoped>
.page-module {
  display: flex;

  .image-code {
    width: 120px;
    height: 120px;
    margin-right: 10px;

    img {
      width: 120px;
      height: 120px;
    }
  }

  .line-text {
    line-height: 20px;
    color: rgba(51, 51, 51, 0.560784);
  }
}
</style>